import React, { useEffect, useState } from 'react';
import Header, { HeaderCart, HeaderNav, Menu, SearchBar, Topbar } from "../Components/Header/Header";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Link, useLocation } from 'react-router-dom';
import Buttons from '../Components/Button/Buttons';
import axios from 'axios';
import config from '../config'; // Assurez-vous que ce fichier contient REACT_APP_API_URL
import { LockKeyhole, UserPlus } from 'lucide-react';

const Headers = (props) => {

    // État pour stocker les données de l'utilisateur
    const [user, setUser] = useState(null);
    const location = useLocation(); // Ajouter useLocation pour écouter les changements de route
    
// Réinitialiser le défilement au début de la page lors de la navigation
    useEffect(() => {
        window.scrollTo(0, 0); // Défilement vers le haut (0, 0)
    }, [location.pathname]); // Déclenché à chaque changement de route

    // Récupérer les données utilisateur si connecté
    useEffect(() => {
        const token = localStorage.getItem('accessToken'); // Correspond au nom utilisé dans exports.login
        if (token) {
            const fetchUserProfile = async () => {
                try {
                    const response = await axios.get(`${config.REACT_APP_API_URL}/user-profile`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
            'x-api-key': config.SITE_API_KEY
                        },
                    });
                    setUser(response.data); // Stocke les données utilisateur (first_name, last_name, etc.)
                } catch (error) {
                    console.error('Erreur lors de la récupération du profil:', error);
                    localStorage.removeItem('accessToken'); // Supprime le token si invalide
                    setUser(null);
                }
            };
            fetchUserProfile();
        }
    }, []);

    return (
        <div>
            {/* Header Start */}
            <Header topSpace={{ desktop: true }} type="reverse-scroll">
                <Topbar className="bg-[#87c03d] text-white py-[8px] border-b border-[#0000001a] sm:hidden md:px-0">
                    <Container fluid className="px-[50px] lg:pr-[65px] font-sans md:px-[30px]">
                        <Row>
                            <Col sm="auto" className="text-center sm:text-start flex items-center">
                                <p className="text-md m-0">
                                    <span className="font-medium text-white">{/* Offer: */} </span>
                                    {/* Worldwide free shipping for all orders of $150 */}
                                </p>
                            </Col>
                            <Col className="sm:block text-end lg:px-0">
                                <div>
                                    <span className="mr-[25px] md:pr-0 text-sm md:mr-[15px]">
                                        <i className="feather-phone-call text-md mr-[7px] text-white"></i>
                                        +216 73 298 855
                                    </span>
                                    <span className="lg:inline-block md:hidden text-sm">
                                        <i className="feather-map-pin text-md m-[10px] text-white"></i>
                                        163, Av H.Bourguiba. 4021 Kalaa Esseghira Sousse,Tunisie.
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Topbar>
                <HeaderNav
                    fluid="fluid"
                    theme="light"
                    bg="white"
                    menu="light"
                    className="px-[35px] py-[0px] md:pl-0 md:pr-[15px]"
                    containerClass="pl-[15px] sm:px-0"
                >
                    <Col className="col-auto me-auto ps-lg-0">
                        <Link aria-label="link for" className="flex items-center" to="/">
                            <Navbar.Brand className="inline-block p-0 m-0">
                                <img
                                    className="default-logo"
                                    width="111"
                                    height="36"
                                    loading="lazy"
                                    src="/assets/logo.png"
                                    alt="logo"
                                />
                                <img
                                    className="alt-logo"
                                    width="111"
                                    height="36"
                                    loading="lazy"
                                    src="/assets/logo.png"
                                    alt="logo"
                                />
                                <img
                                    className="mobile-logo"
                                    width="111"
                                    height="36"
                                    loading="lazy"
                                    src="/assets/logo.png"
                                    alt="logo"
                                />
                            </Navbar.Brand>
                        </Link>
                    </Col>
                    <Navbar.Toggle className="order-last md:ml-[17px] md:px-[15px] xs:px-0">
                        <span className="navbar-toggler-line"></span>
                        <span className="navbar-toggler-line"></span>
                        <span className="navbar-toggler-line"></span>
                        <span className="navbar-toggler-line"></span>
                    </Navbar.Toggle>
                    <Navbar.Collapse className="col-auto justify-center menu-order px-lg-0 md:!px-0">
                        <Menu {...props} />
                    </Navbar.Collapse>
                    <Col className="flex flex-row col-auto text-end pe-0 font-size-0">
                        {user ? (
                            // Si l'utilisateur est connecté
                            <div className="flex items-center">
                                <Link to="/dashboard" className="nav-link section-link my-auto">
                                    <Buttons
                                        type="submit"
                                        aria-label="espace client"
                                        className="btn-fill rounded-none font-medium font-serif mb-0 uppercase sm:mb-[15px]"
                                        themeColor="#558927"
                                        size="xs"
                                        color="#fff"
                                        title="Espace Client"
                                    />
                                </Link>
                            </div>
                        ) : (
                            <div className="flex items-center gap-3">
                            <div className="tooltip-container">
            <Link to="/register" className="nav-link section-link my-auto">
                <UserPlus
                    className="text-darkgray hover:text-[#558927] text-[20px]"
                />
            </Link>
            <span className="tooltip-text">Créer un Compte</span>
        </div>
        <div className="tooltip-container">
            <Link to="/login-register" className="nav-link section-link my-auto">
                <LockKeyhole
                    className="text-darkgray hover:text-[#558927] text-[20px]"
                />
            </Link>
            <span className="tooltip-text">Se connecter</span>
        </div>
                            </div>
                        )}
                        <HeaderCart className="xs:pl-[15px]" />
                    </Col>
                </HeaderNav>
            </Header>
            {/* Header End */}
        </div>
    );
};

export default Headers;